import { Box, Container, Paper } from "@mui/material";
import styled from "@emotion/styled";
import { APP_HEADER_HEIGHT } from "./components/MainHeader.style";

export const MainBody = styled(Box)({
  height: `calc(100vh - ${APP_HEADER_HEIGHT + 1}px)`, // 1px is divider line
  display: "flex",
});

export const MainContent = styled(Container)({
  paddingTop: 16,
  flexGrow: 1,
});

export const MainSidebarRoot = styled(Paper)({
  borderRadius: 0,
});
